import { IconComponent } from './types';

const InRowIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_775_75"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="12"
    >
      <rect width="12" height="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_775_75)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49182 3.70046L11.6744 5.88301C11.8083 6.01695 11.8083 6.23409 11.6744 6.36803L9.49182 8.55058C9.35789 8.68452 9.14074 8.68452 9.00681 8.55058C8.87287 8.41665 8.87287 8.1995 9.00681 8.06557L10.6039 6.46848L4.57275 6.46848L4.57275 5.78256L10.6039 5.78256L9.00681 4.18547C8.87287 4.05154 8.87287 3.83439 9.00681 3.70046C9.14074 3.56652 9.35789 3.56652 9.49182 3.70046Z"
        fill="currentColor"
      />
      <path
        d="M4.57274 6.12551C4.57274 7.38824 3.5491 8.41189 2.28637 8.41189C1.02364 8.41189 0 7.38824 0 6.12551C0 4.86279 1.02364 3.83914 2.28637 3.83914C3.5491 3.83914 4.57274 4.86279 4.57274 6.12551Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default InRowIcon;
